export default "__VITE_ASSET__seNSdCFN__"